module.exports = (function () {
    // функция getProducts
    // данные заполняются в Export.php compose()
    let products = $('[data-p-info][data-products]').data('products'); // см templates/main/catalog/base.tpl
    let params = $('[data-p-info][data-params]').data('params');
    let header = $('[data-p-info][data-header]').data('header');

    /*
    console.log("Init: ");
    console.log("params: ");
    console.log(params);
    console.log("products: ");
    console.log(products);
    console.log("header: ");
    console.log(header);
    console.log("Done");
     */

    if (!params || !products || !header) return [];

    let items = [];
    let set = function (arr, name) {
        let values = [];
        arr.map((id) => {
            if (params[name] && params[name][id]) values.push(params[name][id]);
        });
        return values;
    };

    products.map(function (item) {
        let e = {};
        for (let i in header) e[header[i]] = item[i];
        e.brand = params.brands[e.brand_id].name;
        e.color = params.colors[e.color_id].name;
        if(!params.types[e.type_id]){
            console.log('type_id '+e.type_id+' for types '+JSON.stringify(params.types));
            console.log('item'+JSON.stringify(item));
            e.type  = 'колготки';
        }else{
            e.type  = params.types[e.type_id].name;
        }

        //e.ware_type = item.ware_type;

        e.features = set(e.feature, 'features');
        e.collections = set(e.collection, 'collections'); // fill in Export.php
        e.providers = set(e.available3, 'providers'); // fill in Export.php

        // console.log('===================================================');
        //console.log(e.available3);

        e.m_sole = set(e.materials_sole, 'materials_sole');
        e.m_top = set(e.materials_top, 'materials_top');

        ['materials_insole','materials_top','materials_sole','materials_lining','features'].map((param) => {
            e.search += '|' + set(e[param], param).map((one) => { return one.name; }).join('|');
        });

        e.sizes = e.sizes.map((s) => {
            s.url = e.slug + '#' + s.size;
            return s;
        });
        // console.log(e.sizes);

        if(e.sizes[0] && e.sizes[e.sizes.length-1]){
            e.sizes_str = e.sizes[0].size+'-'+e.sizes[e.sizes.length-1].size;
        }else{
            e.sizes_str = "нет";
        }


        if (e.sizes.length <= 6) {
            e.sizes_min = e.sizes;
        } else {
            e.sizes_min = [];
            e.sizes_min.push(...e.sizes.slice(0,2));
            e.sizes_min.push({size: '...', url: e.slug})
            e.sizes_min.push(...e.sizes.slice(-2));
        }

        e.marksHTML = '';
        if(e.gender==0){
            e.genderHtml = '<img src="/media/icons/icon_boy_ka.svg" height="32" width="32">';
        }else{
            e.genderHtml = '<img src="/media/icons/icon_girl_ka.svg" height="32" width="32">';
        }

        e.price_ = e.price;

        if (e.mark_sale) {
            //e.price_ = Math.floor(e.price * (1 - (e.mark_sale || 0)/100));
            e.price_ = e.price; // для опта не используем
            //e.marksHTML += '<span class="attention sale-mark">-'+e.mark_sale+'%</span>';
            e.marksHTML += '<span class="attention sale-mark">SALE!</span>';
            e.priceHTML = Template('product-price', {
                'old' : e.price,
                'cur' : e.price_
            })
        } else {
            e.priceHTML = e.price + ' руб.';
        }

        if (e.mark_hit) {
            e.marksHTML += '<span class="attention hit-mark">ХИТ!</span>';
        }
        if (e.mark_sale<=0 && e.mark_new) {
            e.marksHTML += '<span class="attention new-mark">NEW</span>';
        }

        items.push(e);
    });

    return items;
});
